import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SEO } from '../components/shared/SEO';
import { CategoryPLP } from './CategoryPLP';
import { Header } from '../components/layout/Header';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { Footer } from '../components/layout/Footer';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { PharmacistChat } from '../components/services/PharmacistChat';
import { MobileDeliverToPill } from '../components/layout/MobileDeliverToPill';
import { MobileHomeHeader } from '../components/MobileHomeHeader';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { generateBreadcrumbJsonLd, generateItemListJsonLd, generateOrganizationJsonLd } from '../utils/seo/jsonLd';
export function CategoryPage() {
  const {
    categoryName
  } = useParams<{
    categoryName: string;
  }>();
  const [searchParams] = useSearchParams();
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<{
    name: string;
  } | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const displayName = categoryName?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') || 'Category';
  const description = `Shop ${displayName} essentials at Innova Pharmacy — top products, great prices, and fast delivery across Saudi Arabia. Secure checkout and 24/7 support.`;
  const categorySlug = categoryName?.toLowerCase().replace(/\s+/g, '-') || 'category';
  const currentPage = parseInt(searchParams.get('page') || '1', 10);
  const isNowContext = true;
  const hasFilters = searchParams.has('brand') || searchParams.has('price') || searchParams.has('sort');
  const canonicalUrl = currentPage > 1 ? `/en/${categorySlug}/?page=${currentPage}` : `/en/${categorySlug}/`;
  const hreflangArUrl = currentPage > 1 ? `/${categorySlug}/?page=${currentPage}` : `/${categorySlug}/`;
  const hreflangEnUrl = currentPage > 1 ? `/en/${categorySlug}/?page=${currentPage}` : `/en/${categorySlug}/`;
  const prevUrl = currentPage > 2 ? `/en/${categorySlug}/?page=${currentPage - 1}` : currentPage === 2 ? `/en/${categorySlug}/` : undefined;
  const nextUrl = currentPage < 5 ? `/en/${categorySlug}/?page=${currentPage + 1}` : undefined;
  const robotsMeta = hasFilters ? 'noindex,follow' : 'index,follow';
  const categoryKeywords = [displayName, 'Saudi Arabia', 'online pharmacy', 'health products', 'authentic products', 'fast delivery'].join(', ');
  // JSON-LD schemas
  const breadcrumbJsonLd = generateBreadcrumbJsonLd([{
    label: 'Home',
    href: '/'
  }, {
    label: displayName
  }]);
  const organizationJsonLd = generateOrganizationJsonLd();
  // Mock products for ItemList schema
  const mockProducts = [{
    id: 1,
    name: 'Sample Product',
    price: 100,
    image: 'https://example.com/product.jpg'
  }];
  const itemListJsonLd = generateItemListJsonLd(mockProducts, displayName);
  const jsonLdSchemas = [breadcrumbJsonLd, organizationJsonLd, itemListJsonLd];
  return <HelmetProvider data-id="element-6509" data-mp="v2oerfnn1uv8">
      <SEO title={displayName} description={description} canonical={canonicalUrl} ogImage={`https://cdn.innovaksa.net/og/${categorySlug}.jpg`} robots={robotsMeta} hreflangAr={hreflangArUrl} hreflangEn={hreflangEnUrl} hreflangDefault={hreflangArUrl} prevUrl={prevUrl} nextUrl={nextUrl} keywords={categoryKeywords} jsonLd={jsonLdSchemas} data-id="element-6510" data-mp="18ztiva3skjnu" />
      <div className="flex flex-col min-h-screen bg-gray-50 overflow-x-hidden" data-id="element-6511" data-mp="1rrdyzcmqmzkd">
        <div className="hidden md:block" data-id="element-6512" data-mp="1npseb53ypgzm">
          <Header locationModalOpen={locationModalOpen} setLocationModalOpen={setLocationModalOpen} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} disableShrink={false} showAnnouncement={true} data-id="element-6513" data-mp="1nmwefb8k0i8j" />
        </div>
        <main className="flex-grow overflow-x-hidden pt-0 md:pt-[var(--header-height-desktop)]" data-id="element-6514" data-mp="3vwmec1mkos50">
          <h1 className="sr-only" data-id="element-6515" data-mp="2y8u529a8q0h2">
            {displayName} - Shop Quality Healthcare Products
          </h1>
          {!isNowContext && <PageHeroBreadcrumb breadcrumbs={[{
          label: 'Home',
          href: '/'
        }, {
          label: displayName
        }]} title={displayName} description={description} data-id="element-6516" data-mp="3375ewk0jcaza" />}
          <CategoryPLP categoryName={displayName} categoryDescription={description} isNowContext={isNowContext} data-id="element-6517" data-mp="nfrderpc5htk" />
        </main>
        <div className="hidden md:block" data-id="element-6518" data-mp="2c0yh4gjxle1u">
          <Footer data-id="element-6519" data-mp="2bzx6ueaqovl6" />
        </div>
        <MobileFooterNav data-id="element-6520" data-mp="27ytptogygtid" />
        <PharmacistChat data-id="element-6521" data-mp="27ybnqb7m3l2j" />
        <div className="h-16 md:hidden" data-id="element-6522" data-mp="2804s1jur5t7d"></div>
      </div>
    </HelmetProvider>;
}